<template>
  <div id="inside" style="">
    <div class="container">
      <div class="row">
        <div
          class="d-flex align-items-start justify-content-start flex-column px-2 pb-4 col-lg-12"
        >
          <div class="btn-group btn-group-sm">
            <a
              class="btn btn-link d-flex flex-column justify-content-center"
              @click="voltar"
              ><i class="fa fa-home fa-fw fa-lg"></i
            ></a>
            <!-- <router-link  v-for="link in links" :key="link.text" :to="{
                  name:link.route,
                }"><a class="btn btn-link">{{link.text}}</a></router-link> -->
          </div>
        </div>
        <div class="col-lg-12">
          <h1>Cadastro</h1>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div
          v-bind:class="
            largura > 500
              ? 'd-inline-flex col-lg-12'
              : 'd-inline-flex col-lg-12 p-0'
          "
          :style="this.largura < 800 ? 'margin: 20px' : ''"
        >
          <div class="card mt-0">
            <div class="card-header" style="">
              <i class="fa fa-fw mr-2 fa-user text-info"></i>Meu cadastro
            </div>
            <div class="card-body pb-5" style="">
              <div class="row">
                <div class="col-md-12 col-12"></div>
              </div>
              <div class="row">
                <!-- <div class="col-12 col-md-1"></div> -->
                <div class="col-12 col-md-12" style="">
                  <p class="m-0 text-info">Nome:</p>
                  <h6 class="">{{ user.FullName }}</h6>
                  <p class="m-0 text-info">
                    {{ user.DocNumber && user.DocNumber.replace(/[.\-/]/g, '').length > 11 ? 'CNPJ:' : 'CPF:' }}
                  </p>
                  <h6>
                    {{ formatDocument(user.DocNumber) }}
                  </h6>
                  <!-- <pre>{{ user }}</pre> -->
                  <p v-if="user.BirthDate" class="m-0 text-info">
                    Data de nascimento:
                  </p>
                  <h6>{{ user.BirthDate }}</h6>
                  <div class="row">
                    <div class="col-md-7" style="">
                      <p class="m-0 text-info">Endereço:</p>
                      <p style="">
                        {{ user.Locale != null ? user.Locale : "" }},
                        {{ user.Number != null ? user.Number : "" }},
                        {{ user.Complement != null ? user.Complement : "" }}
                      </p>
                    </div>
                    <div class="col-md-5" style="">
                      <p class="m-0 text-info">CEP</p>
                      <p style="">
                        {{ user.CEP != null ? formatCep(user.CEP) : "" }}
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-7" style="">
                      <p class="m-0 text-info">Cidade:</p>
                      <p style="">{{ user.City != null ? user.City : "" }}</p>
                    </div>

                    <div class="col-md-5" style="">
                      <p class="m-0 text-info">UF</p>
                      <p style="">{{ user.State != null ? user.State : "" }}</p>
                    </div>
                  </div>
                  <hr />
                  <h5 class="mb-3">Editar cadastro:</h5>
                  <div
                    v-bind:class="largura > 500 ? 'd-flex' : ''"
                    style="justify-content: space-beetwen; align-items: center"
                  >
                    <a
                      id="btn-cadastro"
                      class="btn mr-1 mr-4 btn-outline-primary text-white"
                      style="background-color: #2c6a8a; cursor: pointer"
                      :style="
                        largura > 500
                          ? 'width: 50%;'
                          : 'width: 100%; margin-bottom: 10px;'
                      "
                      @click="alterar"
                      >Alterar dados</a
                    >
                    <a
                      id="btn-cadastro"
                      class="btn mr-1 btn-outline-primary text-white"
                      @click="alterarSenha"
                      style="background-color: #2c6a8a; cursor: pointer"
                      :style="largura > 500 ? 'width: 50%;' : 'width: 100%;'"
                      >Alterar código de acesso</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-1"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  formatCurrencieValueBRL as formatValue,
  formatData,
  formatDocument,
  formatCep,
} from "@/utils/helpers";
export default {
  name: "Leitura",

  components: {},
  data() {
    return {
      links: [],
      loadUserInfo: false,
      userInfo: null,
      largura: null,
    };
  },
  async created() {
    this.largura = window.screen.width;
    this.user.Menus.forEach((menuId) => {
      switch (parseInt(menuId)) {
        case 2:
          this.links.push({
            icon: "",
            text: "Contratos Negociáveis",
            route: "/dashboard/minhas-dividas",
          });
          break;
        case 1:
          this.links.push({
            icon: "",
            text: "Boletos Ativos",
            route: "meusBoletos",
          });
          break;
        case 3:
          this.links.push({
            icon: "",
            text: "Acordos",
            route: "/dashboard/meus-acordos",
          });
          break;
      }
    });
  },
  methods: {
    formatValue,
    formatDocument,
    formatData,
    formatCep,
    ...mapActions("cadastro", ["ActionSetCurrentComponentRegister"]),
    ...mapActions("minhasDividas", ["ActionGetInstallmentsTribanco"]),
    alterar() {
      this.ActionSetCurrentComponentRegister("cadastroAtualizacao");
    },
    alterarSenha() {
      this.ActionSetCurrentComponentRegister("alterarSenha");
    },
    voltar() {
      this.$router.push({ name: "dashboard" });
    },

    async getBoletos() {
      this.loading = true;
      const tag = { tag: localStorage.getItem("tag") };
      const resp = await this.ActionGetInstallmentsTribanco(tag);
      this.$router.push({
        name: "meusBoletos",
        params: { responseFromAgreement: resp },
      });
      return resp;
    },
  },
  computed: {
    ...mapState("auth", ["user", "currentComponent"]),
  },
};
</script>
<style scoped>
.btn-outline-primary:hover {
  background-color: #4a87a5 !important;
}
</style>